/**
 * Content Slider
 *
 * Converts a .content-slider group into a full-slide carousel.
 * Each direct child with class .content-slide is one slide — any
 * block content is allowed inside.
 *
 * Feature flags (CSS classes on the wrapper):
 *   .has-autoplay    — auto-advance every 5 s
 *   .has-indicators  — progress bar indicators below the wrapper
 *   .has-arrows      — prev/next navigation arrows
 *
 * If only one slide exists, no slider UI is rendered.
 */

const INTERVAL = 5000;

function initSlider( wrapper ) {
	const slides = Array.from(
		wrapper.querySelectorAll( ':scope > .content-slide' )
	);

	if ( slides.length <= 1 ) {
		return;
	}

	const useAutoplay   = wrapper.classList.contains( 'has-autoplay' );
	const useIndicators = wrapper.classList.contains( 'has-indicators' );
	const useArrows     = wrapper.classList.contains( 'has-arrows' );

	wrapper.classList.add( 'content-slider--active' );

	let current = 0;
	let timer   = null;

	function show( index ) {
		slides.forEach( ( slide, i ) => {
			slide.classList.toggle( 'is-active', i === index );
		} );
		if ( indicators.length ) {
			indicators.forEach( ( ind, i ) => {
				ind.classList.toggle( 'is-active', i === index );
			} );
		}
		current = index;
	}

	function next() {
		show( ( current + 1 ) % slides.length );
	}

	function prev() {
		show( ( current - 1 + slides.length ) % slides.length );
	}

	function goTo( index ) {
		show( index );
		resetTimer();
	}

	function resetTimer() {
		if ( timer ) {
			clearInterval( timer );
		}
		if ( useAutoplay ) {
			timer = setInterval( next, INTERVAL );
		}
	}

	// Build indicators
	let indicators = [];
	if ( useIndicators ) {
		const indicatorBar = document.createElement( 'div' );
		indicatorBar.className = 'content-slider__indicators';
		slides.forEach( ( _, i ) => {
			const dot = document.createElement( 'div' );
			dot.className = 'content-slider__indicator';
			dot.setAttribute( 'role', 'tab' );
			dot.setAttribute( 'aria-label', `Slide ${ i + 1 }` );
			dot.addEventListener( 'click', () => goTo( i ) );
			indicatorBar.appendChild( dot );
		} );
		wrapper.appendChild( indicatorBar );
		indicators = Array.from(
			indicatorBar.querySelectorAll( '.content-slider__indicator' )
		);
	}

	// Build arrows
	if ( useArrows ) {
		const prevBtn = document.createElement( 'button' );
		prevBtn.className = 'content-slider__arrow content-slider__arrow--prev';
		prevBtn.setAttribute( 'aria-label', 'Previous slide' );
		prevBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		prevBtn.addEventListener( 'click', () => { prev(); resetTimer(); } );

		const nextBtn = document.createElement( 'button' );
		nextBtn.className = 'content-slider__arrow content-slider__arrow--next';
		nextBtn.setAttribute( 'aria-label', 'Next slide' );
		nextBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		nextBtn.addEventListener( 'click', () => { next(); resetTimer(); } );

		wrapper.appendChild( prevBtn );
		wrapper.appendChild( nextBtn );
	}

	show( 0 );
	resetTimer();
}

function init() {
	document.querySelectorAll( '.content-slider' ).forEach( initSlider );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
